import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";

// Function to get color based on progress value
const getProgressColor = (value) => {
  if (value < 25) return "#f44336"; // Red
  if (value < 75) return "#ff9800"; // Yellow/Orange
  return "#4caf50"; // Green
};

const AppraiseeProgress = ({ progress = 75, total = 30 }) => {
  const progressColor = getProgressColor(progress);

  return (
    <Box display="flex" alignItems="center">
      {/* Circular Progress with percentage inside */}
      <Box position="relative" display="inline-flex">
        <CircularProgress
          variant="determinate"
          value={progress}
          size={60}
          thickness={5}
          sx={{
            color: progressColor,
          }}
        />
        <Box
          top={0}
          left={0}
          bottom={0}
          right={0}
          position="absolute"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Typography
            variant="caption"
            component="div"
            color="text.secondary"
            fontSize={12}
          >
            {`${Math.round(progress)}%`}
          </Typography>
        </Box>
      </Box>

      {/* Right side label */}
      <Typography variant="body2" ml={2}>
        Total Appraisee: {total}
      </Typography>
    </Box>
  );
};

export default AppraiseeProgress;
